// src/Redux/Slice/TaskMasterSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const loginData = Cookies.get("loginData");
const parsedData = loginData ? JSON.parse(loginData) : null;

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;

// --- Asynchronous Thunks ---

/*** Thunk to fetch project data from the API. ***/
export const fetchProjectData = createAsyncThunk(
  "TaskMaster/fetchProjectData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TablemangeController/show_project`
      );
      return response.data;
    } catch (error) {
      // Return a more descriptive error message or the server's error response
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

/*** Thunk to fetch sub-task data from the API. ***/
export const fetchSubTaskData = createAsyncThunk(
  "TaskMaster/fetchSubTaskData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/SubTaskMaster/SubTaskFind`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

/*** Thunk to fetch active member data from the API.
 * Note: The endpoint `arfgdfhfghfghhfhhfhgfhgg` seems unusual; ensure it's correct. ***/
export const fetchActiveMemberData = createAsyncThunk(
  "TaskMaster/fetchActiveMemberData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/DynamicInHouseAccounts/arfgdfhfghfghhfhhfhgfhgg`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

/*** Thunk to create a new task by sending data to the API. ***/
export const createTask = createAsyncThunk(
  "TaskMaster/createTask",
  async (taskData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BaseUrl}/TaskManagement`, taskData);
      return response.data; // Return the response data on success
    } catch (error) {
      // Return the error response from the server or a generic message
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Show all task Data
export const fetchAllTask = createAsyncThunk(
  "TaskMaster/Taskfind",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/TaskManagement/Taskfind`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Fetch a task by ID
export const fetchTaskById = createAsyncThunk(
  "TaskMaster/fetchTaskById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/TaskfindId/${id}`
      );
      return response.data; // Assuming response contains task object
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Update Task By ID
export const updateTaskById = createAsyncThunk(
  "TaskMaster/updateTaskById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/TaskManagement/TaskUpdate/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Assign Task Thunk
export const CreateAssignTask = createAsyncThunk(
  "TaskMaster/CreateAssignTask",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/TaskManagement/AssingTask`,
        data
      );
      return response.data; // or response.data.result, depending on API shape
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Fetch a show Assigned Task
export const ShowAssignedTask = createAsyncThunk(
  "TaskMaster/ShowAssignedTask",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/AssingTask/${id}`
      );
      return response.data; // or response.data.result if API wraps data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Assign Task Change Member
export const assignTaskChangeMember = createAsyncThunk(
  "TaskMaster/assignTaskChangeMember",
  async ({ taskId, newMemberId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/AssingTaskChangeMember/${taskId}/${newMemberId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

//  Fetch a Assign Task by ID
export const fetchAssignedSubTaskById = createAsyncThunk(
  "TaskMaster/fetchAssignedSubTaskById",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/Show_Task_id/${taskId}`
      );
      return response.data; // assuming response.data contains relevant data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

//  Fetch a Main Task by ID ( Show Main Task )
export const fetchTaskByCustomId = createAsyncThunk(
  "ShowAllTask/fetchTaskByCustomId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/ShowTaskissd/${id}`
      );
      return response.data; // Adjust if the actual data is nested inside
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Fetch TaskMamner by ID
export const fetchTaskMamnerById = createAsyncThunk(
  "TaskMaster/fetchTaskMamnerById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/ShowTaskid/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Accept Task Thunk
export const AccseptTask = createAsyncThunk(
  "TaskMaster/AccseptTask",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/TaskAccept/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Complete Task Thunk
export const ComplateTask = createAsyncThunk(
  "TaskMaster/ComplateTask",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/ComplateTask/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Fetch SubTask by Member ID
export const fetchSubTaskByMemberId = createAsyncThunk(
  "TaskMaster/fetchSubTaskByMemberId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/ShowSubTaskMember/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Accept Sub Task Thunk
export const TaskSubAccept = createAsyncThunk(
  "TaskMaster/TaskSubAccept",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/TaskSubAccept/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Complete Sub Task Thunk
export const TaskSubComplate = createAsyncThunk(
  "TaskMaster/TaskSubComplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/TaskManagement/TaskSubComplate/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Complaint Data Thunk
export const fetchComplaintData = createAsyncThunk(
  "TaskMaster/fetchComplaintData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/asrfeer34645fgdfgdfgwertghdfgh5/${id}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateCallNo = createAsyncThunk(
  "TaskMaster/updateCallNo",
  async ({ taskId, CallNo, PresentStatus, Requirement, Solution, Benefit }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/ConplainController/updateCallNo/${taskId}`,
        { CallNo, PresentStatus, Requirement, Solution, Benefit }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// InhousRND Complaint Data Thunk
export const fetchInhouseRndData = createAsyncThunk(
  "TaskMaster/fetchInhouseRndData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/InhousRND/${id}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Complaint Complete Thunk
export const fetchComplaintComplete = createAsyncThunk(
  "TaskMaster/fetchComplaintComplete",
  async ({ id, sid }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/asrfeer34645fgdfsdsdgh5/${id}/${sid}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// ConplainController/empdetailsid Complete Thunk
export const empdetailsid = createAsyncThunk(
  "ConplainController/empdetailsid",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/empdetailsid/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// ConplainController/empdetailsid11 Complete Thunk
export const empdetailsid11 = createAsyncThunk(
  "ConplainController/empdetailsid11",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/empdetailsid11/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


// Complaint Complete Thunk
export const TaskChecking = createAsyncThunk(
  "TaskMaster/TaskChecking",
  async (
    { selectedTaskId, selectedSupportId, description },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        `${BaseUrl}/ConplainController/Conplain_Chahingdev/${selectedTaskId.MainId}`,
        {
          DescripTione: description,
          SuportTeamId: selectedSupportId,
          SeniorDevloperID: parsedData?.data?._id,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// InhouseRND Complete Task Thunk
export const InhouseRNDCompleteTask = createAsyncThunk(
  "TaskMaster/InhouseRNDCompleteTask",
  async (
    {
      complainBoxId,
      ratings, // array of developers with { DeveloperID, DeveloperName, rating }
    },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        Ratings: ratings.map((dev) => ({
          InHouseId: dev.DeveloperID,
          DeveloperName: dev.DeveloperName,
          Rating: dev.rating,
        })),
      };

      const response = await axios.post(
        `${BaseUrl}/ConplainController/Conplain_RND/${complainBoxId}`,
        payload
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const findSupport = createAsyncThunk(
  "requestServices/findSupport",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/fteryhdfwe46d345e7rtgdrs`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

// Fetch Junior Developer List
export const findJuniorDevelopers = createAsyncThunk(
  "requestServices/findJuniorDevelopers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/fteryhdfwe46d345e7rtgdsd`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

// --- Accept Task API ---
export const SupportAcceptTask = createAsyncThunk(
  "TaskMaster/SupportAcceptTask",
  async ({ id, tid }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/asrfeer34645fgdfgdfgwertghdfgh5/${id}/${tid}`
      );

      return response.data;
    } catch (error) {
      const callNo = error.response?.data?.data?.[0]?.CallNo;
      const statusMsg = error.response?.data?.status || "Accept Failed";
      return rejectWithValue(
        callNo
          ? `${statusMsg}. Running call no. is ${callNo}`
          : (error.response?.data?.message || statusMsg || error.message)
      );
    }
  }
);

// --- InhousRNDAcceptTask Accept Task API ---
export const InhousRNDAcceptTask = createAsyncThunk(
  "TaskMaster/InhousRNDAcceptTask",
  async ({ id, tid }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/Conplain_ShowInHouse_acc/${id}/${tid}`
      );

      return response.data;
    } catch (error) {
      const callNo = error.response?.data?.data?.[0]?.CallNo;
      const statusMsg = error.response?.data?.status || "Accept Failed";
      return rejectWithValue(
        callNo
          ? `${statusMsg}. Running call no. is ${callNo}`
          : (error.response?.data?.message || statusMsg || error.message)
      );
    }
  }
);

// --- Hold Task API ---
export const SupportHoldTask = createAsyncThunk(
  "TaskMaster/SupportHoldTask",
  async ({ id, tid }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/asrfeer34645fgdfgdfgh5/${id}/${tid}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// --- Senior to Junior Assign Request ---
export const SeniortoJuniorAssignReq = createAsyncThunk(
  "TaskMaster/SeniortoJuniorAssignReq",
  async (
    payload,
    { rejectWithValue }
  ) => {
    try {
      const complainBoxId = payload.complainBoxId || payload.id;
      const targetMemberId = payload.SuportTeamId || payload.SupportTeamId;
      const desc = payload.DescripTione || payload.DescripTion || payload.description || "";
      const seniorId = payload.SeniorDevloperID || payload.seniorId;
      const timeLimit = payload.TimeLimit;

      const response = await axios.post(
        `${BaseUrl}/ConplainController/fteryhdfhb8dsdsdsdsd5e7rtgdrs/${complainBoxId}`,
        {
          SuportTeamId: targetMemberId,
          SupportTeamId: targetMemberId,
          DescripTione: desc,
          SeniorDevloperID: seniorId,
          TimeLimit: timeLimit,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// --- Junior to Senior Assign Request ---
export const JuniorToSeniorAssignReq = createAsyncThunk(
  "TaskMaster/JuniorToSeniorAssignReq",
  async (payload, { rejectWithValue }) => {
    try {
      const complainBoxId = payload?.complainBoxId || payload?.id;
      const targetMemberId = payload?.SuportTeamId || payload?.SupportTeamId;
      const seniorId = payload?.SeniorDevloperID || payload?.seniorId;
      const description = payload?.DescripTione || payload?.DescripTion || payload?.description;

      const response = await axios.post(
        `${BaseUrl}/ConplainController/fteryhdfhb8dsd234d5e7rtgdrs/${complainBoxId}`,
        {
          SuportTeamId: targetMemberId,
          SupportTeamId: targetMemberId,
          DescripTione: description,
          SeniorDevloperID: seniorId,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// --- Junior to Senior Rating Assign Request ---
export const JuniorToSeniorAssignRatingReq = createAsyncThunk(
  "TaskMaster/JuniorToSeniorAssignRatingReq",
  async (payload, { rejectWithValue }) => {
    try {
      const complainBoxId = payload?.complainBoxId || payload?.id;
      const targetMemberId = payload?.SuportTeamId || payload?.SupportTeamId;
      const seniorId = payload?.SeniorDevloperID || payload?.seniorId;
      const description = payload?.DescripTione || payload?.DescripTion || payload?.description;
      const ratings = payload?.ratings || payload?.Ratings || [];

      const body = {
        SuportTeamId: targetMemberId,
        SupportTeamId: targetMemberId,
        DescripTione: description,
        SeniorDevloperID: seniorId,
        Ratings: ratings.map((dev) => ({
          InHouseId: dev.DeveloperID || dev.InHouseId,
          DeveloperName: dev.DeveloperName,
          Rating: dev.rating || dev.Rating || 0,
        })),
      };

      const response = await axios.post(
        `${BaseUrl}/ConplainController/fteryhdfhb8dsd234ddrs/${complainBoxId}`,
        body
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// --- Forward for Implementation Stage ---
export const forwardForImplementationReq = createAsyncThunk(
  "TaskMaster/forwardForImplementationReq",
  async (payload, { rejectWithValue }) => {
    try {
      const complainBoxId = payload?.complainBoxId || payload?.id;
      const targetMemberId = payload?.SuportTeamId || payload?.SupportTeamId || payload?.InHouseId;
      const description = payload?.DescripTione || payload?.DescripTion || payload?.description;

      const response = await axios.post(
        `${BaseUrl}/ConplainController/forwardForImplementation/${complainBoxId}`,
        {
          SuportTeamId: targetMemberId,
          SupportTeamId: targetMemberId,
          DescripTione: description,
          CodeUpdate: payload?.CodeUpdate || payload?.codeUpdate,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// --- Checking after Implementation Stage ---
export const checkingAfterImplementationReq = createAsyncThunk(
  "TaskMaster/checkingAfterImplementationReq",
  async (payload, { rejectWithValue }) => {
    try {
      const complainBoxId = payload?.complainBoxId || payload?.id;
      const targetMemberId = payload?.SuportTeamId || payload?.SupportTeamId || payload?.InHouseId;
      const description = payload?.DescripTione || payload?.DescripTion || payload?.description;

      const response = await axios.post(
        `${BaseUrl}/ConplainController/checkingAfterImplementation/${complainBoxId}`,
        {
          SuportTeamId: targetMemberId,
          SupportTeamId: targetMemberId,
          DescripTione: description,
          CodeUpdate: payload?.CodeUpdate || payload?.codeUpdate,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);



export const Report = createAsyncThunk(
  "TaskMaster/Report",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BaseUrl}/ConplainController/Report`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// --- Redux Slice ---
const taskMasterSlice = createSlice({
  name: "TaskMaster",
  initialState: {
    // Project Data State
    TaskProjectData: [],
    projectLoading: false,
    projectError: null,

    // SubTask Data State
    SubTaskData: [],
    subTaskLoading: false,
    subTaskError: null,

    // Active Member Data State
    ActiveMemberData: [],
    activeMemberLoading: false,
    activeMemberError: null,

    // Task Creation State
    createTaskStatus: "idle",
    createTaskError: null,
    createdTask: null,

    FindAllTask: [],
    FindAllTaskLoading: false,
    FindAllTaskError: null,

    TaskByIdData: null,
    taskByIdLoading: false,
    taskByIdError: null,

    UpdateTaskByIdData: null,
    UpdateTaskByIdLoading: false,
    UpdateTaskByIdError: null,

    // AssignTaskb Data State
    AssignTaskData: null,
    AssignTaskLoading: false,
    AssignTaskError: null,

    // Show Assigned Task Data State
    ShowASsignedTaskData: null,
    ShowAssignedTaskLoading: false,
    ShowAssignedTaskError: null,

    // Assigned Task Change Member Data State
    assignTaskChangeMemberData: null,
    assignTaskChangeMemberLoading: false,
    assignTaskChangeMemberError: null,

    // Show Assigned Task by ID Data State
    AssignedSubTaskData: null,
    AssignedSubTaskLoading: false,
    AssignedSubTaskError: null,

    // Show Main Task Data State
    TaskByCustomIdData: null,
    taskByCustomIdLoading: false,
    taskByCustomIdError: null,

    TaskMamnerData: null,
    taskMamnerLoading: false,
    taskMamnerError: null,

    SubTaskByMemberData: null,
    subTaskByMemberLoading: false,
    subTaskByMemberError: null,

    ComplaintData: null,
    ComplaintLoading: false,
    ComplaintError: null,

    InhousRndData: null,
    InhousrndLoading: null,
    InhousrndError: null,

    ComplaintCompleteData: null,
    ComplaintCompleteLoading: false,
    ComplaintCompleteError: null,

    InhouseRNDCompleteTaskData: null,
    InhouseRNDCompleteTaskLoading: null,
    InhouseRNDCompleteTaskError: null,

    DataFindSupport: null,
    loadingFindSupport: false,
    errorFindSupport: null,

    AccseptTaskData: null,
    AccseptTaskLoading: false,
    AccseptTaskError: null,

    InhousRNDAcceptTaskData: null,
    InhousRNDAcceptTaskLoading: null,
    InhousRNDAcceptTaskError: null,

    ComplateTaskData: null,
    ComplateTaskLoading: false,
    ComplateTaskError: null,

    JuniorDevelopers: null,
    loadingJuniorDevelopers: false,
    errorJuniorDevelopers: null,

    SupportAcceptTaskData: null,
    SupportAcceptTaskLoading: false,
    SupportAcceptTaskError: null,

    SupportHoldTaskData: null,
    SupportHoldTaskLoading: null,
    SupportHoldTaskError: null,

    SeniortoJuniorAssignReqData: null,
    SeniortoJuniorAssignReqLoading: false,
    SeniortoJuniorAssignReqError: null,

    JuniorToSeniorAssignReqData: null,
    JuniorToSeniorAssignReqLoading: false,
    JuniorToSeniorAssignReqError: null,

    JunToSenAssignRatingReqData: null,
    JunToSenAssignRatingReqLoading: null,
    JunToSenAssignRatingReqError: null,

    empdetailsidData: null,
    empdetailsidLoading: null,
    empdetailsidError: null,


    empdetailsid11Data: null,
    empdetailsid11Loading: null,
    empdetailsid11Error: null,


    ReportData: null,
    ReportLoading: null,
    ReportError: null,
  },
  reducers: {
    // You can add synchronous reducers here if needed
    resetCreateTaskStatus: (state) => {
      state.createTaskStatus = "idle";
      state.createTaskError = null;
      state.createdTask = null;
    },
    clearTaskErrors: (state) => {
      state.SupportAcceptTaskError = null;
      state.InhousRNDAcceptTaskError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // --- Project Data Handlers ---
      .addCase(fetchProjectData.pending, (state) => {
        state.projectLoading = true;
        state.projectError = null;
      })
      .addCase(fetchProjectData.fulfilled, (state, action) => {
        state.projectLoading = false;
        state.TaskProjectData = action.payload;
      })
      .addCase(fetchProjectData.rejected, (state, action) => {
        state.projectLoading = false;
        state.projectError = action.payload;
      })

      // --- SubTask Data Handlers ---
      .addCase(fetchSubTaskData.pending, (state) => {
        state.subTaskLoading = true;
        state.subTaskError = null;
      })
      .addCase(fetchSubTaskData.fulfilled, (state, action) => {
        state.subTaskLoading = false;
        state.SubTaskData = action.payload;
      })
      .addCase(fetchSubTaskData.rejected, (state, action) => {
        state.subTaskLoading = false;
        state.subTaskError = action.payload;
      })

      // --- Active Member Data Handlers ---
      .addCase(fetchActiveMemberData.pending, (state) => {
        state.activeMemberLoading = true;
        state.activeMemberError = null;
      })
      .addCase(fetchActiveMemberData.fulfilled, (state, action) => {
        state.activeMemberLoading = false;
        state.ActiveMemberData = action.payload;
      })
      .addCase(fetchActiveMemberData.rejected, (state, action) => {
        state.activeMemberLoading = false;
        state.activeMemberError = action.payload;
      })

      // --- Create Task Handlers ---
      .addCase(createTask.pending, (state) => {
        state.createTaskStatus = "loading";
        state.createTaskError = null;
        state.createdTask = null;
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.createTaskStatus = "succeeded";
        state.createdTask = action.payload;
      })
      .addCase(createTask.rejected, (state, action) => {
        state.createTaskStatus = "failed";
        state.createTaskError = action.payload;
      })

      // --- Find All Task Member Data Handlers ---
      .addCase(fetchAllTask.pending, (state) => {
        state.FindAllTaskLoading = true;
        state.FindAllTaskError = null;
      })
      .addCase(fetchAllTask.fulfilled, (state, action) => {
        state.FindAllTaskLoading = false;
        state.FindAllTask = action.payload;
      })
      .addCase(fetchAllTask.rejected, (state, action) => {
        state.FindAllTaskLoading = false;
        state.FindAllTaskError = action.payload;
      })

      // --- Fetch Task By ID Handlers ---
      .addCase(fetchTaskById.pending, (state) => {
        state.taskByIdLoading = true;
        state.taskByIdError = null;
      })
      .addCase(fetchTaskById.fulfilled, (state, action) => {
        state.taskByIdLoading = false;
        state.TaskByIdData = action.payload;
      })
      .addCase(fetchTaskById.rejected, (state, action) => {
        state.taskByIdLoading = false;
        state.taskByIdError = action.payload;
      })

      // --- Update Task By ID Handlers ---
      .addCase(updateTaskById.pending, (state) => {
        state.UpdateTaskByIdLoading = true;
        state.UpdateTaskByIdError = null;
      })
      .addCase(updateTaskById.fulfilled, (state, action) => {
        state.UpdateTaskByIdLoading = false;
        state.UpdateTaskByIdData = action.payload;
      })
      .addCase(updateTaskById.rejected, (state, action) => {
        state.UpdateTaskByIdLoading = false;
        state.UpdateTaskByIdError = action.payload;
      })

      // --- Create AssignTask Handlers ---
      .addCase(CreateAssignTask.pending, (state) => {
        state.AssignTaskLoading = true;
        state.AssignTaskError = null;
      })
      .addCase(CreateAssignTask.fulfilled, (state, action) => {
        state.AssignTaskLoading = false;
        state.AssignTaskData = action.payload;
      })
      .addCase(CreateAssignTask.rejected, (state, action) => {
        state.AssignTaskLoading = false;
        state.AssignTaskError = action.payload;
      })

      // ---  Show Assigned Task Handlers ---
      .addCase(ShowAssignedTask.pending, (state) => {
        state.ShowAssignedTaskLoading = true;
        state.ShowAssignedTaskError = null;
      })
      .addCase(ShowAssignedTask.fulfilled, (state, action) => {
        state.ShowAssignedTaskLoading = false;
        state.ShowASsignedTaskData = action.payload;
      })
      .addCase(ShowAssignedTask.rejected, (state, action) => {
        state.ShowAssignedTaskLoading = false;
        state.ShowAssignedTaskError = action.payload;
      })

      // ---- Assign Task to Member (Reassign) TaskHandlers ----
      .addCase(assignTaskChangeMember.pending, (state) => {
        state.assignTaskChangeMemberLoading = true;
        state.assignTaskChangeMemberError = null;
      })
      .addCase(assignTaskChangeMember.fulfilled, (state, action) => {
        state.assignTaskChangeMemberLoading = false;
        state.assignTaskChangeMemberData = action.payload;
      })
      .addCase(assignTaskChangeMember.rejected, (state, action) => {
        state.assignTaskChangeMemberLoading = false;
        state.assignTaskChangeMemberError = action.payload;
      })

      // --- Show Assigned Sub Task Handlers ---
      .addCase(fetchAssignedSubTaskById.pending, (state) => {
        state.AssignedSubTaskLoading = true;
        state.AssignedSubTaskError = null;
      })
      .addCase(fetchAssignedSubTaskById.fulfilled, (state, action) => {
        state.AssignedSubTaskLoading = false;
        state.AssignedSubTaskData = action.payload;
      })
      .addCase(fetchAssignedSubTaskById.rejected, (state, action) => {
        state.AssignedSubTaskLoading = false;
        state.AssignedSubTaskError = action.payload;
      })

      // ---  Show Main Task Handlers ---
      .addCase(fetchTaskByCustomId.pending, (state) => {
        state.taskByCustomIdLoading = true;
        state.taskByCustomIdError = null;
      })
      .addCase(fetchTaskByCustomId.fulfilled, (state, action) => {
        state.taskByCustomIdLoading = false;
        state.TaskByCustomIdData = action.payload;
      })
      .addCase(fetchTaskByCustomId.rejected, (state, action) => {
        state.taskByCustomIdLoading = false;
        state.taskByCustomIdError = action.payload;
      })

      // ---- MainTask All Data Api halnder ----
      .addCase(fetchTaskMamnerById.pending, (state) => {
        state.taskMamnerLoading = true;
        state.taskMamnerError = null;
      })
      .addCase(fetchTaskMamnerById.fulfilled, (state, action) => {
        state.taskMamnerLoading = false;
        state.TaskMamnerData = action.payload;
      })
      .addCase(fetchTaskMamnerById.rejected, (state, action) => {
        state.taskMamnerLoading = false;
        state.taskMamnerError = action.payload;
      })

      // --- Show SubTask By Member ID Handlers ---
      .addCase(fetchSubTaskByMemberId.pending, (state) => {
        state.subTaskByMemberLoading = true;
        state.subTaskByMemberError = null;
      })
      .addCase(fetchSubTaskByMemberId.fulfilled, (state, action) => {
        state.subTaskByMemberLoading = false;
        state.SubTaskByMemberData = action.payload;
      })
      .addCase(fetchSubTaskByMemberId.rejected, (state, action) => {
        state.subTaskByMemberLoading = false;
        state.subTaskByMemberError = action.payload;
      })

      // --- Accept SubTask Handlers ---
      .addCase(TaskSubAccept.fulfilled, (state, action) => {
        state.SubTaskByMemberData = action.payload;
      })

      // --- Complete SubTask Handlers ---
      .addCase(TaskSubComplate.fulfilled, (state, action) => {
        state.SubTaskByMemberData = action.payload;
      })

      // --- Fetch Complaint Data ---
      .addCase(fetchComplaintData.pending, (state) => {
        state.ComplaintLoading = true;
        state.ComplaintError = null;
      })
      .addCase(fetchComplaintData.fulfilled, (state, action) => {
        state.ComplaintLoading = false;
        state.ComplaintData = action.payload;
      })
      .addCase(fetchComplaintData.rejected, (state, action) => {
        state.ComplaintLoading = false;
        state.ComplaintError = action.payload;
      })

      // --- Fetch InhousRND Complaint Data ---
      .addCase(fetchInhouseRndData.pending, (state) => {
        state.InhousrndLoading = true;
        state.InhousrndError = null;
      })
      .addCase(fetchInhouseRndData.fulfilled, (state, action) => {
        state.ComplaintLoading = false;
        state.InhousRndData = action.payload;
      })
      .addCase(fetchInhouseRndData.rejected, (state, action) => {
        state.InhousrndLoading = false;
        state.InhousrndError = action.payload;
      })

      // --- Fetch Complaint Completion ---
      .addCase(fetchComplaintComplete.pending, (state) => {
        state.ComplaintCompleteLoading = true;
        state.ComplaintCompleteError = null;
      })
      .addCase(fetchComplaintComplete.fulfilled, (state, action) => {
        state.ComplaintCompleteLoading = false;
        state.ComplaintCompleteData = action.payload;
      })
      .addCase(fetchComplaintComplete.rejected, (state, action) => {
        state.ComplaintCompleteLoading = false;
        state.ComplaintCompleteError = action.payload;
      })

      .addCase(findSupport.pending, (state) => {
        state.loadingFindSupport = true;
        state.errorFindSupport = null;
      })
      .addCase(findSupport.fulfilled, (state, action) => {
        state.loadingFindSupport = false;
        state.DataFindSupport = action.payload;
      })
      .addCase(findSupport.rejected, (state, action) => {
        state.loadingFindSupport = false;
        state.errorFindSupport = action.payload;
      })

      // --- Accept Task ---
      .addCase(AccseptTask.pending, (state) => {
        state.AccseptTaskLoading = true;
        state.AccseptTaskError = null;
      })
      .addCase(AccseptTask.fulfilled, (state, action) => {
        state.AccseptTaskLoading = false;
        state.AccseptTaskData = action.payload;
      })
      .addCase(AccseptTask.rejected, (state, action) => {
        state.AccseptTaskLoading = false;
        state.AccseptTaskError = action.payload;
      })

      // --- Complate Task ---
      .addCase(ComplateTask.pending, (state) => {
        state.ComplateTaskLoading = true;
        state.ComplateTaskError = null;
      })
      .addCase(ComplateTask.fulfilled, (state, action) => {
        state.ComplateTaskLoading = false;
        state.ComplateTaskData = action.payload;
      })
      .addCase(ComplateTask.rejected, (state, action) => {
        state.ComplateTaskLoading = false;
        state.ComplateTaskError = action.payload;
      })

      // --- InhouseRND Complate Task ---
      .addCase(InhouseRNDCompleteTask.pending, (state) => {
        state.InhouseRNDCompleteTaskLoading = true;
        state.InhouseRNDCompleteTaskError = null;
      })
      .addCase(InhouseRNDCompleteTask.fulfilled, (state, action) => {
        state.InhouseRNDCompleteTaskLoading = false;
        state.InhouseRNDCompleteTaskData = action.payload;
      })
      .addCase(InhouseRNDCompleteTask.rejected, (state, action) => {
        state.InhouseRNDCompleteTaskLoading = false;
        state.InhouseRNDCompleteTaskError = action.payload;
      })

      // --- Find Junior Developers ---
      .addCase(findJuniorDevelopers.pending, (state) => {
        state.loadingJuniorDevelopers = true;
        state.errorJuniorDevelopers = null;
      })
      .addCase(findJuniorDevelopers.fulfilled, (state, action) => {
        state.loadingJuniorDevelopers = false;
        state.JuniorDevelopers = action.payload;
      })
      .addCase(findJuniorDevelopers.rejected, (state, action) => {
        state.loadingJuniorDevelopers = false;
        state.errorJuniorDevelopers = action.payload;
      })

      // --- Customer Support Accept Task (Complaint Accept) ---
      .addCase(SupportAcceptTask.pending, (state) => {
        state.SupportAcceptTaskLoading = true;
        state.SupportAcceptTaskError = null;
      })
      .addCase(SupportAcceptTask.fulfilled, (state, action) => {
        state.SupportAcceptTaskLoading = false;
        state.SupportAcceptTaskData = action.payload;
      })
      .addCase(SupportAcceptTask.rejected, (state, action) => {
        state.SupportAcceptTaskLoading = false;
        state.SupportAcceptTaskError = action.payload;
      })

      // --- Customer Support Hold Task (Complaint Hold) ---
      .addCase(SupportHoldTask.pending, (state) => {
        state.SupportAcceptTaskLoading = true;
        state.SupportAcceptTaskError = null;
      })
      .addCase(SupportHoldTask.fulfilled, (state, action) => {
        state.SupportAcceptTaskLoading = false;
        state.SupportHoldTaskData = action.payload;
      })
      .addCase(SupportHoldTask.rejected, (state, action) => {
        state.SupportAcceptTaskLoading = false;
        state.SupportAcceptTaskError = action.payload;
      })

      // --- InhouseRND Support Accept Task (InhouseRND Accept) ---
      .addCase(InhousRNDAcceptTask.pending, (state) => {
        state.InhousRNDAcceptTaskLoading = true;
        state.InhousRNDAcceptTaskError = null;
      })
      .addCase(InhousRNDAcceptTask.fulfilled, (state, action) => {
        state.InhousRNDAcceptTaskLoading = false;
        state.InhousRNDAcceptTaskData = action.payload;
      })
      .addCase(InhousRNDAcceptTask.rejected, (state, action) => {
        state.InhousRNDAcceptTaskLoading = false;
        state.InhousRNDAcceptTaskError = action.payload;
      })

      // --- Senior to Junior Assign Request Handlers ---
      .addCase(SeniortoJuniorAssignReq.pending, (state) => {
        state.SeniortoJuniorAssignReqLoading = true;
        state.SeniortoJuniorAssignReqError = null;
      })
      .addCase(SeniortoJuniorAssignReq.fulfilled, (state, action) => {
        state.SeniortoJuniorAssignReqLoading = false;
        state.SeniortoJuniorAssignReqData = action.payload;
      })
      .addCase(SeniortoJuniorAssignReq.rejected, (state, action) => {
        state.SeniortoJuniorAssignReqLoading = false;
        state.SeniortoJuniorAssignReqError = action.payload;
      })

      // --- Junior to Senior Assign Request Handlers ---
      .addCase(JuniorToSeniorAssignReq.pending, (state) => {
        state.JuniorToSeniorAssignReqLoading = true;
        state.JuniorToSeniorAssignReqError = null;
      })
      .addCase(JuniorToSeniorAssignReq.fulfilled, (state, action) => {
        state.JuniorToSeniorAssignReqLoading = false;
        state.JuniorToSeniorAssignReqData = action.payload;
      })
      .addCase(JuniorToSeniorAssignReq.rejected, (state, action) => {
        state.JuniorToSeniorAssignReqLoading = false;
        state.JuniorToSeniorAssignReqError = action.payload;
      })

      // --- Junior to Senior Assign Rating Request Handlers ---
      .addCase(JuniorToSeniorAssignRatingReq.pending, (state) => {
        state.JunToSenAssignRatingReqLoading = true;
        state.JunToSenAssignRatingReqError = null;
      })
      .addCase(JuniorToSeniorAssignRatingReq.fulfilled, (state, action) => {
        state.JuniorToSeniorAssignReqLoading = false;
        state.JunToSenAssignRatingReqData = action.payload;
      })
      .addCase(JuniorToSeniorAssignRatingReq.rejected, (state, action) => {
        state.JunToSenAssignRatingReqLoading = false;
        state.JunToSenAssignRatingReqError = action.payload;
      })

      .addCase(empdetailsid.pending, (state) => {
        state.empdetailsidLoading = true;
        state.empdetailsidError = null;
      })
      .addCase(empdetailsid.fulfilled, (state, action) => {
        state.empdetailsidLoading = false;
        state.empdetailsidData = action.payload;
      })
      .addCase(empdetailsid.rejected, (state, action) => {
        state.empdetailsidLoading = false;
        state.empdetailsidError = action.payload;
      })



      .addCase(Report.pending, (state) => {
        state.ReportLoading = true;
        state.ReportError = null;
      })
      .addCase(Report.fulfilled, (state, action) => {
        state.ReportLoading = false;
        state.ReportData = action.payload;
      })
      .addCase(Report.rejected, (state, action) => {
        state.ReportLoading = false;
        state.ReportError = action.payload;
      })




      .addCase(empdetailsid11.pending, (state) => {
        state.empdetailsid11Loading = true;
        state.empdetailsid11Error = null;
      })
      .addCase(empdetailsid11.fulfilled, (state, action) => {
        state.empdetailsid11Loading = false;
        state.empdetailsid11Data = action.payload;
      })
      .addCase(empdetailsid11.rejected, (state, action) => {
        state.empdetailsid11Loading = false;
        state.empdetailsid11Error = action.payload;
      });
  },
});

// Export any actions you define in `reducers`
export const { resetCreateTaskStatus, clearTaskErrors } = taskMasterSlice.actions;

// Export the reducer
export default taskMasterSlice.reducer;
